import React, {forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useRef, useState} from "react";
import {Button, ConfigProvider, Dropdown, Flex, Input, Modal, Tree,Tooltip} from "antd";
import {
    CaretDownOutlined,
} from "@ant-design/icons";
import {
    createNoteElementByNote,
    generateRandomPageKey, getImagePathWithTheme,
    getItem, getNoteFirstHtmlForLeftCard,
    imgPathPerfix, isFileElement, isNoteElement,
    isStringNullOrEmpty,
    MenuItem, removeHtmlTags,
    replaceNoteNameFromElementHtml
} from "../../utils";
import {FieldDataNode} from "rc-tree/lib/interface";
import {nanoid} from "nanoid";
import {TreeProps} from "antd/es/tree";
import {
    EVENT_ADD_NOTE,
    EVENT_ADD_NOTE_BY_CARD,
    EVENT_CANVAS_COPY_ADD_IFRAME,
    EVENT_CANVAS_DELETE_ELEMENT,
    EVENT_CANVAS_SELECT_IFRAME,
    EVENT_COPY_DOC_NOTE,
    EVENT_COPY_DOC_NOTE_FROM_ELEMENT,
    EVENT_DELETE_HTML_NOTE,
    EVENT_DELETE_LEFT_CARD,
    EVENT_DELETE_LEFT_CARD_BAT,
    EVENT_ELEMENT_DELETE_FROM_ACTION,
    EVENT_FAVIRIATE_CHANGE,
    EVENT_NOTE_DELETE,
    EVENT_NOTE_READONLY_STATUS,
    EVENT_NOTE_READONLY_STATUS_1,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_RECENTS,
    EVENT_SELECT_ELEMENT_IN_CANVAS_BY_ELEID,
    EVENT_SET_NOTE_DATA,
    EVENT_UPDATE_NOTE,
    EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD,
    FROM_LIBRARY,
    KEY_CANVAS_NOTE_ORDER_BY,
    KEY_CANVAS_NOTE_SORT_TYPE,
    KEY_CARD_SORT_TYPE,
    KEY_NEW_PROJECT_ID,
    POST_MESSAGE_RENAME_SUB_NOTENAME, SYS_CONFIG_KEY_ORDER_BY, SYS_CONFIG_KEY_SORT_TYPE,
    TREENODETYPE
} from "@/Const";
import DialogNote from "@/views/Draw/DialogNote";
import style from "./TreeListNode.module.less";
import {addEventListener, postMessage, recvMessage, triggerEvent, unSubscribe} from "@/common/event";
import {useTranslation} from "react-i18next";
import "./TreeListNode.css"
import clipboard from "clipboardy";
import {IconAddBlack, IconDelete, IconFolder, IconMakeCopy, IconNote, IconRename, IconTreeFolder} from "@/Icon";
import {closeEditor, openEditor} from "@/state";
import Global from "@/global";
import DialogMessageBox from "@/common/DialogMessageBox";
import {updateMindmapNoteImgCache} from "../../../@excalidraw/packages/excalidraw/element/mindMap";
import {deleteCard, getCardById, getCardDoc, updateCard} from "@model/card";
import {APP_WEB, isWebApp} from "@/electron_interactive";
import {apiProjectCardRefUpdate} from "@/api/AppApi";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";
import {t} from "i18next";
import {menu} from "../../../@excalidraw/packages/excalidraw/components/icons";
import Icon, {CheckOutlined, DownOutlined, FolderOutlined, MoreOutlined, SearchOutlined} from '@ant-design/icons';
import {getSysConfig} from "@model/sysconfig";
import {loopAllNode} from "@/TreeUtils";

const {DirectoryTree} = Tree;
type DataNode = FieldDataNode<{
    key:string;
    title?:string;
    editValue?:string;
    isEditable?:boolean;
    isFolder:boolean;
    drawJson:any;
    children?:any;
    icon:any;
    isSelected?:boolean;
    isHover?:boolean;
}>

let mSelectNode:any;
let mIsAddFolder:boolean = false;
let lastClickTime:any;
let mszMessageBoxAction:string;
let arrayMenuDataLastest:any=[];//最新的菜单。。。。
let mPendingElement:any;
let mPendingTreeNoteData;
let isMoreOpend:boolean = false;
let isMoreMenuClicked:boolean = false;
let mRootDiv:any = null;//drag的folder....
let mSelectFolder:any = null;
let mIsDefaultDragOk = false;
let mIsContextMenuClicked = false;
let mIsFullScreenDialog = false;
let mDragNoteInfo:any;//当前在拖动的...

const TreeListNode = forwardRef(function _TreeListNode(props:{title:string,treeNodeType:TREENODETYPE,leftMenuItemClicked:any,onInsertNoteData:any,leftMenuDeleteNotes:any,onGetBroadData:any,getCurrentDrawJson?:any},ref){
    useImperativeHandle(ref,()=>({
        onEditNoteData:onEditNoteData,
        getTreeNoteData:getTreeNoteData,
        setTreeNoteData:setTreeNoteData,
        onGetPageDataById:onGetPageDataById,
        onEditNoteDataByNoteId:onEditNoteDataByNoteId,
        onSelectNoteByKey:onSelectNoteByKey,
        updateAllPageHasUpdateSign:updateAllPageHasUpdateSign,
        newProject:newProject,
        getDragNoteInfo:getDragNoteInfo,
        onAddOrUpdateDatas:onAddOrUpdateDatas,
    }));
    const dialogNoteRef = useRef<any>();
    const dialogMessageBoxRef = useRef(null);
    const {t} = useTranslation();

    const mMenuData:any = useRef();

    const defaultItem:DataNode = {
        title:t("Default note"),
        key:nanoid(),
        icon:<IconNote/>,
        isFolder:false,
        drawJson:[]
    }
    const defaultDialogNoteEditSize = {w:'560px',h:'680px'};
    const [menuData,setMenuData] = useState<DataNode[]>([])
    const [arrayFilterMenuData,setArrayFilterMenuData] = useState([]);
    const [expandKeys,setExpandKeys] = useState([]);
    const [treeSelectedKeys,setTreeSelectedKeys] = useState([]);
    const [treeDraggable,setTreeDraggable] = useState(true);
    const [isMessageBoxShow,setIsMessageBoxShow] = useState(false);
    const [isShowNoteDialog,setIsShowNoteDialog] = useState(false);
    const [dialogNoteEditSize,setDialogNoteEditSize] = useState(defaultDialogNoteEditSize);
    const [isDialogFullScreen,setIsDialogFullScreen] = useState(false);
    const [isReadOnlyMode,setIsReadonlyMode] = useState(false);
    const [sortMenuOpen, setSortMenuOpen] = useState(false);

    const drawJsonRef = useRef(null);

    const items: MenuItem[] = [
        getItem(t("Create copy"), 'copy', <IconMakeCopy/>, undefined,undefined,()=>{
            onMenuItemContextMenu("copy")
        }),
        getItem(t("Rename"), 'rename', <IconRename/>, undefined,undefined,()=>{
            onMenuItemContextMenu("rename")
        }),
        getItem(t("Remove"), 'delete', <IconDelete/>, undefined,undefined,()=>{
            onMenuItemContextMenu("delete")
        }),
        getItem(t("Delete from library"), 'deleteFromLibaray', <IconDelete/>, undefined,undefined,()=>{
            onMenuItemContextMenu("deleteFromLibaray")
        }),
    ];

    const [sortMenu, setSortMenu] = useState([
        {
            key: "sort by",
            type: 'group',
            label: t('Sort by'),
            children: [
                {
                    key: 'sort by name',
                    label: t("alphabetical"),
                    icon: <CheckOutlined style={{color:'white',fontSize:'0px'}}/>
                },
                {
                    key: 'sort by createDate',
                    label: t('Date created')
                },
                {
                    key: 'sort by updateDate',
                    label: t('Last viewed')
                }
            ]
        },
        {
            key: "order",
            type: 'group',
            label: t('Order'),
            children: [
                {
                    key: 'date asc',
                    label: t('Oldest first')
                },
                {
                    key: 'date desc',
                    label: t('Newest first')
                }
            ]
        }
    ])

    const onMenuItemContextMenu = (szAction:any)=>{
        mIsContextMenuClicked = true;

        mszMessageBoxAction = szAction;
        const data = [...menuData];
        if("copy" == szAction){
            makeACopy(treeSelectedKeys[0]);
        }else if("rename" == szAction){
            loop(data, treeSelectedKeys[0], (item) => {
                item.isEditable = true;
                item.editValue = item.title;
            });
            setMenuData(data)
            setTreeDraggable(false);
        }else if("delete" == szAction){
            // setIsMessageBoxShow(true);
            let msg = t("Delete note not restore");
            loop(data, treeSelectedKeys[0], (item,num,node,parent) => {
                if(item.isFolder){
                    msg = t("Delete the folder")
                }
            });
            onDeleteNoteData(treeSelectedKeys[0]);

            // dialogMessageBoxRef.current?.onShowDialog(t("Tips"),msg,t("Delete"),()=>{
            //     onDeleteNoteData(treeSelectedKeys[0]);
            // })
        }else if('deleteFromLibaray' == szAction){
            window.showMessageBox(t("Tips"),t("ConfirmDeleteLibraryItem"),t("Cancel"),t("Delete"),null,()=>{
                onDeleteNoteData(treeSelectedKeys[0]);
                getCardById(treeSelectedKeys[0])?.then(res=>{
                    res.isDeleted = 1;
                    updateCard(res).then(ress=>{
                        postMessage(EVENT_REFRESH_LIBRARY_LIST)
                    });
                })
            })
        }

        setTimeout(()=>{
            mIsContextMenuClicked = false;
        },1000);
    }


    useEffect(()=>{
        setDialogNoteEditSize(defaultDialogNoteEditSize);
        setIsDialogFullScreen(false);

        window.addEventListener("resize",()=>{
            onResize();
        })

        recvMessage(EVENT_CANVAS_SELECT_IFRAME,(msg,data)=>{
            if(!isStringNullOrEmpty(data.detail)){
                setTreeSelectedKeys([data.detail]);
            }else{
                setTreeSelectedKeys([]);
            }
        })

        setTimeout(()=>{
            const div = document.getElementById('div-tree-note');
            if (div){
                const arrayShitTrees = div.getElementsByClassName('ant-tree-list-holder-inner');
                for (let i=0;i<arrayShitTrees.length;i++){
                    const ddddd = arrayShitTrees[i];
                    ddddd.classList.add('draw-ant-tree-list-holder-inner-shit-ant-tree')
                }
            }
        },100);

        /**
         * 这里当前borad或者什么更改的时候更新下
         */
        window.onUpdateNoteFilter = ()=>{
            const arrayNewFilters:any = [];
            const drawJson:any = props.getCurrentDrawJson();
            mMenuData.current.forEach(p=>{
                const isExist = filterCurrentNotes(p,drawJson);
                if (isExist){
                    arrayNewFilters.push(p);
                }
            })
            sortNote(arrayNewFilters)
            setArrayFilterMenuData(arrayNewFilters);
        }

        //初始排序选中状态
        updateSortStates();

        return ()=>{
            delete window.methodGetNoteById;
            delete window.onUpdateNoteFilter;
            unSubscribe(EVENT_CANVAS_SELECT_IFRAME)
        }
    },[])

    useEffect(()=>{
        mMenuData.current = menuData;
        window.onUpdateNoteFilter();
    },[menuData])


    useEffect(()=>{
        recvMessage(EVENT_ADD_NOTE,(msg,data)=>{
            onAddItem();
        },true);
        //保存笔记............
        recvMessage(EVENT_UPDATE_NOTE,(msg:any,data:any)=>{
            onCloseNoteEvent(true,data.data.data,data.data.isInsertCanvas,data.data.from != FROM_LIBRARY,data.data.isSaveDb);
            if (!data.data.isAutoSave){
                //更新mindmap中的缩略图....如果有的话...
                updateMindmapNoteImgCache(data.data.data)
            }
        });

        //来自直接在画布中的编辑更新
        recvMessage(EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD,(msg,data)=>{
            var arrayNewMenuData = [...menuData];
            loop(arrayNewMenuData,data.data.id,((node, i1) => {
                node.title = data.data.name;
                node.editValue = node.title;
                node.noteDataDoc = data.data.doc;
                node.hasUpdate = true;
                node.hasRef = true;
                node.updateTime = Date.now();
                setMenuData(arrayNewMenuData);
            }))
        })

        recvMessage(EVENT_COPY_DOC_NOTE,(msg:any,data:any)=>{
            const szId = generateRandomPageKey();
            const szName = data.data.name+"("+t("Copy")+")";
            onAddNewCanvas(szName,szId,data.data.doc);
            //复制的，保存到card
            //更新到card表--
            var card = {
                id:szId,
                name:szName,
                doc:data.data.doc,
                type:'card'
            }
            updateCard(card);

        },true);

        //删除笔记
        recvMessage(EVENT_DELETE_HTML_NOTE,(msg,data)=>{
            onDeleteNoteData(data.data.id);
        },true);

        //从元素上复制笔记...
        recvMessage(EVENT_COPY_DOC_NOTE_FROM_ELEMENT,(msg,data)=>{
            var arrayNews = data.data.elements;
            var arrayCards = [];

            for (let i=0;i<arrayNews.length;i++){
                const item = arrayNews[i];
                if (isNoteElement(item)){
                    if (item.customData?.generationData){
                        // for (let j=0;j<menuData.length;j++){
                        //     //只考虑一级笔记
                        //     const itemNote = menuData[j];
                        //     if (itemNote.key == item.customData.generationData.id){
                        //
                        //         break;
                        //     }
                        // }
                        // loop(menuData,item.customData?.generationData.key,(node, i, data, parent)=>{
                        //     onAddNewCanvas(item.customData.generationData.name,item.id,replaceNoteNameFromElementHtml(item.customData.generationData.name,node.noteDataDoc));
                        // })

                        //已经有相同的了。。。。
                        if (menuData.some(p=>p.key == item.customData.generationData.id))continue;

                        arrayCards.push({
                            id:item.customData.generationData?.id??item.id,
                            name:item.customData.generationData.name,
                            noteDataDoc:item.customData.generationData.html
                        });
                        // onAddNewCanvas(item.customData.generationData.name,item.customData.generationData?.id??item.id,replaceNoteNameFromElementHtml(item.customData.generationData.name,item.customData.generationData.html));
                        //更新到CARD。。。。--同一个board的才需要在库中新建一个card
                        if (data.data.isSameBoard == true){
                            var card = {
                                id:item.customData.generationData?.id??item.id,
                                name:item.customData.generationData.name,
                                doc:item.customData.generationData.html,
                                type:item.customData.generationData.libraryType || 'card'
                            }
                            updateCard(card).then(res=>{
                                postMessage(EVENT_REFRESH_LIBRARY_LIST);
                            })
                        }
                    }
                }
            }
            onAddMultiplyNewCanvas(arrayCards);

        },true);

        //通过card创建笔记-添加到侧栏，添加到library
        recvMessage(EVENT_ADD_NOTE_BY_CARD,(msg,data)=>{
            var arrayNews = data.data;
            for (let i=0;i<arrayNews.length;i++) {
                const item = arrayNews[i];
                updateCard(item).then(res=>{
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                })
            }
            onAddMultiplyNewCanvas(arrayNews)
        })

        recvMessage(EVENT_DELETE_LEFT_CARD,(msg,data)=>{
            var newData = [...menuData];
            var selectPreNode = null;
            const szSelectKey = data.data.id;
            loop(newData,data.data.id,((node, i,data,parent) => {
                if(parent != null){
                    parent.children.splice(i,1);
                    if(i < parent.children.length){
                        selectPreNode = parent.children[i];
                    }
                }else{
                    newData.splice(i,1);
                    if(i < newData.length){
                        selectPreNode = newData[i];
                    }
                }
            }))
            setMenuData(newData);
            //删除别的画布的引用
            props.leftMenuDeleteNotes(szSelectKey);
        })

        //批量删除
        recvMessage(EVENT_DELETE_LEFT_CARD_BAT,(msg,data)=>{
            var arrayNewData:any = [];

            for (let i=0;i<menuData.length;i++){
                const item = menuData[i];
                let isDelete = data.data.elements.some(p=>p.id == item.key || p.customData?.generationData?.id == item.key);
                if (!isDelete){
                    arrayNewData.push(item);
                }
            }

            setMenuData(arrayNewData);
            //删除别的画布的引用
            // props.leftMenuDeleteNotes(szSelectKey);
        })

        //这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用这里其实就是刷新卡片的引用
        //这里收到的通知和 EVENT_DELETE_LEFT_CARD 收到的通知的menuData 竟然不是同一个。。。这个东西太TM奇葩用了。
        recvMessage(EVENT_ELEMENT_DELETE_FROM_ACTION,(msg,data)=>{
            setTimeout(()=>{
                var arrayNew = [...mMenuData.current]
                refreshCardRef(arrayNew);
                setMenuData(arrayNew);
            },1000)
        })

        return()=>{
            unSubscribe(EVENT_UPDATE_NOTE);
            unSubscribe(EVENT_ADD_NOTE_BY_CARD);
            unSubscribe(EVENT_DELETE_LEFT_CARD);
            unSubscribe(EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD);
            unSubscribe(EVENT_DELETE_LEFT_CARD_BAT);
            unSubscribe(EVENT_ELEMENT_DELETE_FROM_ACTION);
        }
    })

    /**
     * 公共的事件......
     * @param szId
     */
    window.methodGetNoteById = async (szId:string)=>{
        if (APP_WEB){
            for (let i=0;i<menuData.length;i++){
                if (menuData[i].key == szId){
                    let node = menuData[i];
                    return{
                        id:node.key,
                        name:node.title,
                        doc:node.noteDataDoc
                    }
                }
            }
            return null;
        }
        const dbCard = await getCardById(szId);
        return dbCard;
    }



    /**
     * 新project clear...
     */
    const newProject = ()=>{
        setTreeNoteData([])
    }

    /**
     * 当前在拖动的。。。。
     */
    const getDragNoteInfo = ()=>{
        return mDragNoteInfo;
    }

    const makeACopy = (szKey)=>{
        const data = [...menuData];

        loop(data, szKey, (item,index,type,parent) => {
            var newItem = Object.assign({},item);
            newItem.title = newItem.editValue = newItem.title+"("+t("Copy")+")"
            newItem.key = nanoid();
            if(parent != undefined){
                parent.children.splice(index+1,0,newItem);
            }else{
                data.splice(index+1,0,newItem);
            }
            //最新的。。。。。
            arrayMenuDataLastest = data;
            setMenuData(data);
            selectNewItemAndNav(newItem,data);

            //保存到library
            var card = {
                id:newItem.key,
                name:newItem.title,
                doc:newItem.noteDataDoc,
                type:'card'
            }
            updateCard(card).then(res=>{
                postMessage(EVENT_REFRESH_LIBRARY_LIST);
            });
            //画布添加
            postMessage(EVENT_CANVAS_COPY_ADD_IFRAME,{oldKey:item.key,newKey:newItem.key});
        });
    }
    /**
     * 编辑笔记数据
     * @param element
     */
    const onEditNoteData = async (element:any,isReadOnlyMode:boolean = false)=>{
        mPendingElement = element;
        //需要找一下这个笔记的标题
        let bOk = false;
        loop(menuData,element.id,((node, i) => {
            if (node.noteDataDoc){
                bOk = true;
                mPendingElement.name = node.title;
                mPendingElement.customData.generationData.html = node.noteDataDoc;//createNoteElementByNote(node.title,node.noteDataDoc);

                Global.g_currentNoteData = {id:node.key, name:node?.title,doc:node?.noteDataDoc}
                openEditor(node?.key);

                setTimeout(()=>{
                    postMessage(EVENT_NOTE_READONLY_STATUS,{isReadOnlyStatus:isReadOnlyMode})
                    postMessage(EVENT_NOTE_READONLY_STATUS_1,{isReadOnlyStatus:isReadOnlyMode});
                },100);
            }
        }))
        if (!bOk){
            //不在左侧栏，直接去数据库找.
            const card:any = await getCardById(element.customData?.generationData?.id);
            if (card){
                mPendingElement.name = card.name;
                mPendingElement.customData.generationData.html = card.doc;//createNoteElementByNote(card.name,card.doc);

                Global.g_currentNoteData = {id:card.id, name:card.name,doc:card.doc}
                openEditor(card.id);

                setTimeout(()=>{
                    postMessage(EVENT_NOTE_READONLY_STATUS,{isReadOnlyStatus:isReadOnlyMode})
                    postMessage(EVENT_NOTE_READONLY_STATUS_1,{isReadOnlyStatus:isReadOnlyMode});
                },100);
            }
        }
        setDialogNoteEditSize(defaultDialogNoteEditSize);
        resetNoteDialog();
        setIsReadonlyMode(isReadOnlyMode);
        setIsShowNoteDialog(true);
    }

    /**
     * 删除笔记
     * @param id
     */
    const onDeleteNoteData = (id)=>{
        mszMessageBoxAction = "delete";
        onMessageBoxOk(id);
    }

    /**
     * 根据笔记的ID打开一个笔记--链接查看的情况
     * @param id
     */
    const onEditNoteDataByNoteId = (id:string,isReadOnlyMode:boolean = false)=>{
        loop(menuData,id,((node, i, data, parent) => {
            mSelectNode = node;
            //打开笔记
            mPendingElement = {
                name:mSelectNode.title,
                id:mSelectNode.key,
                customData:{
                    generationData:{
                        html:mSelectNode.noteDataDoc
                    }
                }
            };

            Global.g_currentNoteData = {id:mSelectNode.key, name:mSelectNode?.title,doc:mSelectNode?.noteDataDoc}
            openEditor(mSelectNode?.key);

            postMessage(EVENT_NOTE_READONLY_STATUS,{isReadOnlyStatus:isReadOnlyMode})
            postMessage(EVENT_NOTE_READONLY_STATUS_1,{isReadOnlyStatus:isReadOnlyMode});

            // setDialogNoteEditSize(defaultDialogNoteEditSize);
            // resetNoteDialog();
            // setIsReadonlyMode(true);
            // setIsShowNoteDialog(true);
        }))
    }

    /**
     * 选中
     * @param szKey
     */
    const onSelectNoteByKey = (szKey,szParentKey)=>{
        setTreeSelectedKeys([szKey]);
        if (!isStringNullOrEmpty(szParentKey)){
            setExpandKeys([szParentKey]);
        }
    }

    /**
     * 标记为已更新.....
     */
    const updateAllPageHasUpdateSign = ()=>{
        var arrayNew = [...menuData];
        for (let i=0;i<arrayNew.length;i++){
            const item = arrayNew[i];
            if (item.isFolder){
                for (let j=0;j<item.children.length;j++){
                    item.children[j].hasUpdate = false;
                }
            }else{
                arrayNew[i].hasUpdate = false;
            }
        }
        setMenuData(arrayNew);
    }

    /**
     * 树结构数据
     */
    const getTreeNoteData = ()=>{
        return menuData;
    }

    const hasCardRef = ()=>{


    }

    /**
     * 刷新卡片在画布上的引用.
     */
    function refreshCardRef(arrayNew:any,arrayCanvas){
        // var arrayNew = [...menuData];
        let arrayBoard = arrayCanvas;
        if (!arrayBoard){
            arrayBoard = props.onGetBroadData();
        }
        let arrayAllElements:any = [];
        loopAllNode(arrayBoard,(node)=>{
            if (node.drawJson?.elements){
                arrayAllElements.push(...node.drawJson.elements)
            }
        })

        for (let i=0;i<arrayNew.length;i++){
            const item = arrayNew[i];
            item.hasRef = arrayAllElements.some(p=>item.key == p.customData?.generationData?.id || item.key == p.id);
        }

        // setTimeout(()=>{
        //     setMenuData(arrayNew);
        // },10);
    }

    /**
     * 根据ID获取TREE 数据
     * @param id
     */
    function onGetPageDataById(id,generationDataId){
        let q;
        loop(menuData,id,((node, i, data, parent) => {
            q = node;
        }));
        if (!q){
            loop(menuData,generationDataId,((node, i, data, parent) => {
                q = node;
            }));
        }
        return q;
    }

    /**
     * 重置树数据
     * @param treeNoteData
     */
    const setTreeNoteData = (treeNoteData,arrayCanvas)=>{
        if(treeNoteData == undefined){
            treeNoteData = [];
        }else{
            recursionUpdateOutMenuIcon(treeNoteData);
        }
        refreshCardRef(treeNoteData,arrayCanvas);
        setMenuData(treeNoteData);
        setExpandKeys([]);
        setTreeSelectedKeys([]);
    }

    //递归更新....
    function recursionUpdateOutMenuIcon(menuData:any){
        for(var i=0;i<menuData.length;i++){
            var item = menuData[i];
            if(item.isFolder){
                item.icon = <IconTreeFolder/>;
                recursionUpdateOutMenuIcon(item.children);
            }else{
                item.icon = <IconNote rev={undefined}/>;
            }
        }
    }

    //添加子画布
    const onAddItem = ()=>{
        // mIsAddFolder = false;
        // let szDefaultName = "新建画布";
        // if(props.treeNodeType == TREENODETYPE.TREE_NODE_TYPE_NOTES){
        //     szDefaultName = "新建笔记";
        // }
        // onAddNewCanvas(szDefaultName);
        Global.g_currentNoteData = {id:generateRandomPageKey()}
        openEditor(Global.g_currentNoteData.id);

        mPendingElement = null;
        resetNoteDialog();
        setIsShowNoteDialog(true);
    }
    //添加文件夹画布
    const onAddFolder = ()=>{
        mIsAddFolder = true;
        onAddNewCanvas(t("New folder"));
    }

    /**
     * 添加或更新
     * @param id
     * @param szTitle
     * @param noteDataDoc
     */
    const onAddOrUpdateDatas = (id:string,szTitle:string,noteDataDoc:string)=>{
        let arrayNew = [...menuData];
        const arrayExists = arrayNew.filter(p=>p.key == id);
        let item;
        if (arrayExists.length > 0){
            item = arrayExists[0];
        }else{
            item =  {
                title:szTitle,
                editValue:szTitle,
                key:id,
                icon:<IconNote />,
                isFolder:false,
                isEditable:false,
                noteDataDoc:noteDataDoc,
                hasUpdate:true,
                hasRef:true,
                createTime:Date.now(),
                updateTime:Date.now()
            };
            arrayNew.push(item);
        }
        item.title = item.editValue = szTitle;
        item.noteDataDoc = noteDataDoc;
        setMenuData(arrayNew);

        //选中新建
        // selectNewItemAndNav(item,arrayNew);
    }

    /**
     * 一次添加多个.....
     * @param arrayCards
     */
    const onAddMultiplyNewCanvas = (arrayCards:any)=>{
        //添加到子画布
        let menuDataNew:any = [...menuData];
        let expandKeysNew:any = [...expandKeys];

        for (let i=0;i<arrayCards.length;i++){
            const item = arrayCards[i];
            if (menuDataNew.some(p=>p.key == item.id))continue;

            const itemNew =  {
                title:item.name,
                editValue:item.name,
                key:item.id,
                icon:<IconNote />,
                isFolder:false,
                isEditable:false,
                noteDataDoc:item.noteDataDoc,
                hasUpdate:true,
                hasRef:true,
                createTime:Date.now(),
                updateTime:Date.now()
            };
            if(mSelectNode != null && mSelectNode.isFolder){
                //添加到最后---NEW
                menuDataNew.push(...menuData);
            }
            menuDataNew.push(itemNew);
        }

        setMenuData(menuDataNew);
        setExpandKeys(expandKeysNew);
        //选中新建-最后一个.
        selectNewItemAndNav(menuDataNew[menuDataNew.length-1],menuDataNew);
    }

    //添加画布
    const onAddNewCanvas = (szInputTitle:string,id=generateRandomPageKey(),noteDataDoc:any=undefined)=>{
        if(mIsAddFolder){
            //文件夹...
            let menuDataNew:any = [];
            const itemNew = {
                title:szInputTitle,
                editValue:szInputTitle,
                key:id,
                icon:<IconTreeFolder/>,
                isFolder:mIsAddFolder,
                isEditable:true,
                children:[],
            }
            if(mSelectNode == undefined){
                mSelectNode = menuData[0];
            }
            if(mSelectNode != null && mSelectNode.isFolder){
                // mSelectNode.children.push(itemNew);
                menuDataNew.push(...menuData);
                //不能无限嵌套---->插入到当前选中的后面一个位置...
                loop(menuDataNew, treeSelectedKeys[0], (_, index, arr,parent) => {
                    if(parent != undefined && parent.isFolder){
                        parent.children.splice(index+1,0,itemNew);
                    }else{
                        menuDataNew.splice(index+1,0,itemNew);
                    }
                });
            }else{
                menuDataNew.push(...menuData)
                if(menuDataNew.length == 0){
                    menuDataNew.push(itemNew);
                }else{
                    if(treeSelectedKeys.length > 0){
                        //插入到当前选中的后面一个位置...
                        loop(menuDataNew, treeSelectedKeys[0], (_, index, arr,parent) => {
                            if(parent != undefined && parent.isFolder){
                                // parent.children.splice(index+1,0,itemNew);
                                //不能无限嵌套--插入到最后
                                menuDataNew.push(itemNew);
                            }else{
                                menuDataNew.splice(index+1,0,itemNew);
                            }
                        });
                    }else{
                        menuDataNew.push(itemNew);
                    }
                }
            }
            setMenuData(menuDataNew);
            //选中新建
            mSelectNode = itemNew;
            setTreeSelectedKeys([itemNew.key])
            canvaItemSelect(menuDataNew);

            setTreeDraggable(false);
        }else{
            //添加到子画布
            let menuDataNew:any = [];
            let expandKeysNew:any = [...expandKeys];
            const itemNew =  {
                title:szInputTitle,
                editValue:szInputTitle,
                key:id,
                icon:<IconNote />,
                isFolder:mIsAddFolder,
                isEditable:false,
                noteDataDoc:noteDataDoc,
                hasUpdate:true,
                createTime:Date.now(),
                updateTime:Date.now()
            };
            if(mSelectNode != null && mSelectNode.isFolder){
                // mSelectNode.children.push(itemNew);
                // menuDataNew.push(...menuData);
                // expandKeysNew.push(mSelectNode.key);
                //添加到最后---NEW
                menuDataNew.push(...menuData);
                menuDataNew.push(itemNew);
            }else{
                menuDataNew.push(...menuData);
                if(menuDataNew.length == 0){
                    menuDataNew.push(itemNew);
                }else{
                    if(treeSelectedKeys.length > 0){
                        //插入到当前选中的后面一个位置...
                        loop(menuDataNew, treeSelectedKeys[0], (_, index, arr,parent) => {
                            if(parent != undefined && parent.isFolder){
                                parent.children.splice(index+1,0,itemNew);
                            }else{
                                menuDataNew.splice(index+1,0,itemNew);
                            }
                        });
                    }else{
                        menuDataNew.push(itemNew);
                    }
                }
            }

            setMenuData(menuDataNew);
            setExpandKeys(expandKeysNew);
            //选中新建
            selectNewItemAndNav(itemNew,menuDataNew);

            onUpdateForServer(menuDataNew);
        }
    }

    /**
     * 更新到服务端
     * @param menuDataNew
     */
    const onUpdateForServer = (menuDataNew:any)=>{
        if (isWebApp()){
            //增加一个排序-保存到服务端
            var arrayProjectCardRef:any = [];
            for (let i=0;i<menuDataNew.length;i++){
                menuDataNew[i].sort = i;
                arrayProjectCardRef.push({
                    projectId:PROJECT_ID,//localStorage.getItem(KEY_NEW_PROJECT_ID),
                    libraryId:menuDataNew[i].key,
                    sort:i
                })
            }
            //更新到服务端
            apiProjectCardRefUpdate(arrayProjectCardRef)
        }
    }

    //选中并转到新建的.
    const selectNewItemAndNav = (itemNew:any,arrayNewMenu:any)=>{
        if (!itemNew)return;
        mSelectNode = itemNew;
        setTreeSelectedKeys([itemNew.key])
        canvaItemSelect(arrayNewMenu);
    }

    const canvaItemSelect =(menuNewData:any)=>{
        if(mSelectNode != null && !mSelectNode.isFolder){
            props.leftMenuItemClicked(mSelectNode,menuNewData);
        }

        //打开笔记
        if (mSelectNode != null){
            postMessage(EVENT_SET_NOTE_DATA,{name:mSelectNode.title,doc:mSelectNode.noteDataDoc})
        }
    }

    // 找到节点数据并回调处理节点方法 callback回调: node-当前节点 i-当前节点序号 data-包含当前节点的节点组 parentNode 当前节点父节点
    const loop = (
        data: DataNode[],
        key: React.Key,
        callback: (node: DataNode, i: number, data: DataNode[], parent?: DataNode) => void,
        parentNode?: DataNode,
    ) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].key === key) {
                return callback(data[i], i, data, parentNode);
            }
            if (data[i].children) {
                loop(data[i].children!, key, callback, data[i]);
            }
        }
    };

    const onTreeMouseEnter:TreeProps["onMouseEnter"] = (event)=>{
        console.log(event);
        var newData = [...menuData];
        resetHoverStatus(newData,event.node.key);
        setMenuData(newData);
    }

    const onTreeMouseLeave:TreeProps["onMouseLeave"] = (event)=>{
        var newData = [...menuData];
        resetHoverStatus(newData,"");
        setMenuData(newData);
    }

    const loopRemove=(data,key)=>{
        for (var i=0;i<data.length;i++){
            var item = data[i];
            if (item.isFolder){
                for (var j=0;j<item.children.length;j++){
                    var subItem = item.children[j];
                    if (subItem.key === key){
                        item.children.splice(j,1);
                        return subItem;
                    }
                }
            }else{
                if (item.key === key){
                    data.splice(i,1);
                    return item;
                }
            }
        }
    }

    /**
     * 重置状态
     * @param data
     * @param key
     */
    const resetHoverStatus = (data:any,key:any)=>{
        for (let i = 0; i < data.length; i++) {
            if (data[i].key === key) {
                data[i].isHover = true;
            }else{
                data[i].isHover = false;
            }
            if (data[i].children) {
                resetHoverStatus(data[i].children!, key);
            }
        }
    }

    const onExpand:TreeProps["onExpand"]=((expandedKeys:any, expanded) => {
        setExpandKeys(expandedKeys);
    })
    /**
     * tree选择.....
     */
    const onSelect:TreeProps["onSelect"] =(async (selectedKeys:any, info) => {
        // console.log('onSelect');
        // console.log(info)
        // clipboard.write(info.node.key);
        if (mIsContextMenuClicked)return;

        var now = new Date().getTime();
        if(now - lastClickTime < 300){
            //双击
            const data = [...menuData];
            loop(data, selectedKeys[0], (item) => {
                item.isEditable = true;
                item.editValue = item.title;
            });
            setMenuData(data)
            setTreeDraggable(false);
        }else{
            if(treeSelectedKeys == null && treeSelectedKeys.length == 0 /*&& treeSelectedKeys[0] == selectedKeys[0]*/){
                return;
            }
            setTreeSelectedKeys(selectedKeys);
            mSelectNode = info.node
            lastClickTime = new Date().getTime();
            if (info.selectedNodes.length > 0){
                var node = info.selectedNodes[0];
                if (node.isFolder)return;
            }

            //打开笔记
            mPendingElement = {
                name:mSelectNode.title,
                id:mSelectNode.key,
                customData:{
                    generationData:{
                        html:mSelectNode.noteDataDoc
                    }
                }
            };
            if (isMoreOpend || isMoreMenuClicked){
                isMoreMenuClicked = false;
                isMoreOpend = false;
            }else{
                if (mSelectNode.hasRef){
                    //有引用，转到....
                    postMessage(EVENT_SELECT_ELEMENT_IN_CANVAS_BY_ELEID, {id:mSelectNode.key,isCard:true});
                }else{
                    if (!mSelectNode?.noteDataDoc){
                        mSelectNode.noteDataDoc = await getCardDoc(mSelectNode.key);
                    }
                    Global.g_currentNoteData = {id:mSelectNode.key, name:mSelectNode?.title,doc:mSelectNode?.noteDataDoc}
                    openEditor(mSelectNode?.key);

                    setIsShowNoteDialog(true);
                    resetNoteDialog();
                }
            }

            //重置所有未选择
            mSelectNode.isSelected = true;
            canvaItemSelect(menuData);
        }

        lastClickTime = new Date().getTime();
    })

    const onDragStart = (info)=>{
        console.log('onDragStart');
        mDragNoteInfo = info.node;
    }

    const onDragOver = (info)=>{
        // console.log('onDragOver');
        // console.log(info.node);
        mIsDefaultDragOk = false;

        if(mRootDiv != null){
            mRootDiv.style.border = '0px';
        }
        mSelectFolder = null;

        if(info.node.isFolder){
            mRootDiv = info.event.currentTarget;
            mRootDiv.style.border = '1px solid #0085FF';
            mSelectFolder = mRootDiv;
        }else{
            //根据ID找到父级
            loop(menuData,info.node.key,((node, i, data, parent) => {
                if(parent != undefined){
                    var div = document.getElementById(parent.key);
                    if(div != undefined){
                        mRootDiv = div.parentElement.parentElement.parentElement;
                        mRootDiv.style.border = '1px solid #0085FF';
                    }
                }
            }))
        }
    }

    const onDragEnd = (info)=>{
        console.log('onDragEnd')

        setTimeout(()=>{
            //不要太早置空，那边还没收到消息...
            mDragNoteInfo = null;
        },1000);

        if(mRootDiv != null){
            mRootDiv.style.border = '0px'
        }

        if (mSelectFolder != null && !mIsDefaultDragOk){
            let szMoveKey = info.node.key;
            if (info.dragNode != undefined){
                szMoveKey = info.dragNode.key;
            }
            var arrayDivs = mSelectFolder.getElementsByClassName("custom-element");
            if (arrayDivs.length > 0){
                setTimeout(()=>{
                    var szDestKey = arrayDivs[0].id;
                    var arrayNew = [...menuData];
                    for (var i=0;i<arrayNew.length;i++){
                        var item = arrayNew[i];
                        if (item.key === szDestKey && item.isFolder){
                            //移动到的父级....
                            //从原来的里面删除
                            var newNode = loopRemove(arrayNew,szMoveKey);
                            item.children.push(newNode);
                            setMenuData(arrayNew);
                            break;
                        }
                    }
                },50);
            }
        }
    }

    const onDrop: TreeProps['onDrop'] = (info) => {
        console.log("onDrop***");
        console.log(info);
        // onDragEnd(info);
        if(mRootDiv != null){
            mRootDiv.style.border = '0px'
        }

        var isDragOk = true;
        const dropKey = info.node.key;
        const dragKey = info.dragNode.key;
        const dropPos = info.node.pos.split('-');
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
        // const loop = (
        //     data: DataNode[],
        //     key: React.Key,
        //     callback: (node: DataNode, i: number, data: DataNode[]) => void,
        // ) => {
        //     for (let i = 0; i < data.length; i++) {
        //         if (data[i].key === key) {
        //             return callback(data[i], i, data);
        //         }
        //         if (data[i].children) {
        //             loop(data[i].children!, key, callback);
        //         }
        //     }
        // };
        const data = [...menuData];

        // Find dragObject
        let dragObj: DataNode;
        loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });

        mIsDefaultDragOk = false;

        if (!info.dropToGap) {
            // Drop on the content
            loop(data, dropKey, (item) => {
                if(item.children == null){//不能移到画布下。。。。
                    //插入到当前下...
                    var nCurIndex = data.indexOf(item);
                    data.splice(nCurIndex+1,0,info.dragNode as DataNode);
                    isDragOk = true;
                }else{
                    if (info.dragNode.isFolder && item.isFolder){
                        isDragOk = false;
                    }else{
                        item.children = item.children || [];
                        // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
                        item.children.unshift(dragObj);
                    }
                }
            });
            mIsDefaultDragOk = true;
        } else if (
            ((info.node as any).props.children || []).length > 0 && // Has children
            (info.node as any).props.expanded && // Is expanded
            dropPosition === 1 // On the bottom gap
        ) {
            loop(data, dropKey, (item,num,data) => {
                if(item.children == null) {//不能移到画布下。。。。
                    isDragOk = false;
                }else{
                    if (info.dragNode.isFolder && item.isFolder){
                        isDragOk = false;
                    }else{
                        item.children = item.children || [];
                        // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
                        item.children.unshift(dragObj);
                        // in previous version, we use item.children.push(dragObj) to insert the
                        // item to the tail of the children
                    }
                }
            });
        } else {
            let ar: DataNode[] = [];
            let i: number;
            loop(data, dropKey, (_item, index, arr,parent) => {
                if ((info.dragNode.isFolder && (_item.isFolder || parent?.isFolder))){
                    isDragOk = false;
                }else{
                    ar = arr;
                    i = index;
                }
            });
            if (dropPosition === -1) {
                ar.splice(i!, 0, dragObj!);
            } else {
                ar.splice(i! + 1, 0, dragObj!);
            }
        }
        if(isDragOk){
            setMenuData(data);
            //排序后保存到服务端...
            onUpdateForServer(data);
        }

        if (menuData.length != data.length){
            mIsDefaultDragOk = true;
        }
    };

    // input 改变
    const onChange = (e:any, key:any) => {
        const data = [...menuData];
        loop(data, key, (item) => {
            item.editValue = e.target.value;
            item.title = item.editValue;
        });
        setMenuData(data);

    };

    //丢失焦点
    const onBlur = (e:any,key:any)=>{
        const data = [...menuData];
        var treeItem = undefined;
        loop(data, key, (item) => {
            item.editValue = e.target.value;
            item.title = item.editValue;
            item.isEditable = false;
            treeItem = item;
            postMessage(POST_MESSAGE_RENAME_SUB_NOTENAME,{key:item.key,name:item.title});
        });
        setMenuData(data)
        setTreeDraggable(true);
    }

    const onCanvasKeyPress = (e,key)=>{
        if (e.charCode == 13){
            e.currentTarget.blur();
        }
    }

    //第一个画布...
    function getFirstCanvasNode(arrayMenuDatas:any){
        for(var i=0;i<arrayMenuDatas.length;i++){
            var item = arrayMenuDatas[i];
            if(item.isFolder){
                getFirstCanvasNode(item.children);
            }else{
                return item;
            }
        }
    }

    //弹出确认框
    const onMessageBoxOk = (szKey)=>{
        setIsMessageBoxShow(false);

        if("delete" == mszMessageBoxAction){
            //删除
            //会自动跳转到同一个层级的上一个画布
            //如果删除的是文件夹里的第一个画布（或者唯一的子画布），就自动跳转到项目的第一个画布
            var newData = [...menuData];
            var selectPreNode = null;
            const szSelectKey = szKey;
            loop(newData,szKey,((node, i,data,parent) => {
                if(parent != null){
                    parent.children.splice(i,1);
                    if(i < parent.children.length){
                        selectPreNode = parent.children[i];
                    }
                }else{
                    newData.splice(i,1);
                    if(i < newData.length){
                        selectPreNode = newData[i];
                    }
                }
            }))
            setMenuData(newData);
            /*
            if(selectPreNode == null){
                selectPreNode = getFirstCanvasNode(newData);
            }
            mSelectNode = selectPreNode;
            setTreeSelectedKeys([mSelectNode?.key]);
            canvaItemSelect(newData);

             */

            // triggerEvent(EVENT_CANVAS_DELETE_NOTE,szSelectKey)
            postMessage(EVENT_CANVAS_DELETE_ELEMENT,szSelectKey);

            //删除别的画布的引用
            props.leftMenuDeleteNotes(szSelectKey);

        }
    }

    /**
     * 重置弹出对话框大小
     */
    const resetNoteDialog = ()=>{
        setIsReadonlyMode(false);
        setIsDialogFullScreen(false);
        setDialogNoteEditSize(defaultDialogNoteEditSize);
    }

    //笔记编辑对话框关闭---
    const onCloseNoteEvent = (isSave:boolean,noteData:any,isInsertCanvas:boolean,bAutoInsertNoteList=true,isSaveDb=true)=>{
        //如果noteData为空并且是新插入的note则不保存
        if (isStringNullOrEmpty(removeHtmlTags(noteData.doc)) && (isStringNullOrEmpty(noteData.name) || noteData.name.toLowerCase() == 'untitled')){
            if (isStringNullOrEmpty(noteData.id) || !menuData.some(p=>p.key == noteData.id)){
                //新的不保存
                return;
            }
        }
        resetNoteDialog();
        setTreeSelectedKeys([]);
        setIsShowNoteDialog(false);
        if(isSave){
            mIsAddFolder = false;
            var bExist = false;
            //只新列表OR添加新的画布
            var arrayNewMenuData = [...menuData];
            loop(arrayNewMenuData,noteData.id,((node, i1) => {
                bExist = true;
                node.title = noteData.name;
                node.editValue = node.title;
                node.noteDataDoc = noteData.doc;
                node.hasUpdate = true;
                node.updateTime = Date.now();
                setMenuData(arrayNewMenuData);
            }))
            // for(var i=0;i<arrayNewMenuData.length;i++){
            //     var item = arrayNewMenuData[i];
            //     if (item.key === noteData.id){
            //         bExist = true;
            //         item.title = noteData.showName;
            //         item.editValue = item.title;
            //         item.noteDataDoc = noteData.doc;
            //         setMenuData(arrayNewMenuData);
            //         break;
            //     }
            // }
            if(!bExist && bAutoInsertNoteList){
                if (isStringNullOrEmpty(noteData.id)){
                    noteData.id = generateRandomPageKey()
                }
                //添加到左侧列表
                onAddNewCanvas(noteData?.name,noteData.id,noteData.doc);
            }

            //更新到card表--
            var card = {
                ...noteData,
                type:noteData.type || 'card'
            }
            if (isSaveDb || isSaveDb == undefined){
                updateCard(card).then(res=>{
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                });
            }

            //笔记内容插入或更新到画布
            props.onInsertNoteData(noteData,isInsertCanvas);
        }
    }

    const onDialogDismiss = ()=>{
        setIsShowNoteDialog(false);
        setTreeSelectedKeys([]);
        dialogNoteRef?.current.onSaveEvent(true,false);
    }

    //对话框全屏
    const onFullScreen = ()=>{
        setIsDialogFullScreen(true);
        mIsFullScreenDialog = true;
        onResize(true);
    }

    const onResize = (isUpdate=true)=>{
        if(mIsFullScreenDialog){
            const nWidth = document.body.clientWidth;
            const nHeight = document.body.clientHeight-22;
            setDialogNoteEditSize({
                w:nWidth+'px',
                h:nHeight+'px'
            })
        }
    }

    const onMoreClick = (item)=>{
        isMoreMenuClicked = true;
    }

    const onMoreOpenChanged = (isVisible)=>{
        isMoreOpend = isVisible;
    }

    /**
     * 过滤当前的笔记...
     * @param item
     */
    const filterCurrentNotes = (item,drawJson)=>{
        if(!drawJson){
            drawJson = props.getCurrentDrawJson();
        }
        let isExist = (drawJson.elements.some(p=>isNoteElement(p) && (p.id == item.key || p.customData?.generationData?.id == item.key)));
        if (!isExist){
            //所有都不在的...
            if (!item.hasRef){
                isExist = true;
            }
        }
        return isExist;
    }

    const sortNote = (arrayNotes:any)=>{
        let szSortType = localStorage.getItem(KEY_CANVAS_NOTE_SORT_TYPE) || "sort by updateDate";
        let szOrderBy = localStorage.getItem(KEY_CANVAS_NOTE_ORDER_BY) || "date desc";

        //补充一下列表的时间...
        arrayNotes.forEach(async (p)=>{
            const dbCard:any = await getCardById(p.key,false);
            if (dbCard){
                p.createTime = dbCard.createTime;
                p.updateTime = dbCard.updateTime;
                p.viewTime = dbCard.viewTime;
            }
        })

        if("sort by name" === szSortType){
            if("a-z" === szOrderBy){
                arrayNotes.sort((a,b)=>{
                    let szTitleA = a.title;
                    if (!szTitleA){
                        szTitleA = getNoteFirstHtmlForLeftCard(a.noteDataDoc)
                    }
                    let szTitleB = b.title;
                    if (!szTitleB){
                        szTitleB = getNoteFirstHtmlForLeftCard(b.noteDataDoc);
                    }
                    return szTitleA.localeCompare(szTitleB);
                })
            }else if("z-a" == szOrderBy){
                arrayNotes.sort((a,b)=>{
                    let szTitleA = a.title;
                    if (!szTitleA){
                        szTitleA = getNoteFirstHtmlForLeftCard(a.noteDataDoc)
                    }
                    let szTitleB = b.title;
                    if (!szTitleB){
                        szTitleB = getNoteFirstHtmlForLeftCard(b.noteDataDoc);
                    }
                    return szTitleB.localeCompare(szTitleA);
                })
            }
        }else if("sort by createDate" == szSortType){
            if("date asc" == szOrderBy){
                arrayNotes.sort((a,b)=>{
                    return a.createTime - b.createTime;
                })
            }else if("date desc" == szOrderBy){
                arrayNotes.sort((a,b)=>{
                    return b.createTime - a.createTime;
                })
            }
        } else if("sort by updateDate" == szSortType){
            if("date asc" == szOrderBy){
                arrayNotes.sort((a,b)=>{
                    return a.updateTime - b.updateTime;
                })
            }else if("date desc" == szOrderBy){
                arrayNotes.sort((a,b)=>{
                    return b.updateTime - a.updateTime;
                })
            }
        }
    }

    const updateSortStates = async ()=>{
        let szSortType = localStorage.getItem(KEY_CANVAS_NOTE_SORT_TYPE) || "sort by updateDate";
        let szOrderBy = localStorage.getItem(KEY_CANVAS_NOTE_ORDER_BY) || "date desc";

        var arraySortMenus = [...sortMenu];
        if ("sort by name" == szSortType) {
            var sortMenuA = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'a-z',
                        label: 'A-Z',
                        icon: <CheckOutlined />,
                    },
                    {
                        key: 'z-a',
                        label: 'Z-A'
                    }
                ]
            }
            arraySortMenus[1] = sortMenuA;
        } else {
            var sortMenuDate = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'date asc',
                        label: t('Oldest first')
                    },
                    {
                        key: 'date desc',
                        label: t('Newest first')
                    }
                ]
            }
            arraySortMenus[1] = sortMenuDate;
        }

        var item0 = arraySortMenus[0];
        for(var i=0;i<item0.children.length;i++){
            var child = item0.children[i];

            if(child.key == szSortType){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        var item1 = arraySortMenus[1];
        for(var i=0;i<item1.children.length;i++){
            var child = item1.children[i];

            if(child.key == szOrderBy){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        setSortMenu(arraySortMenus);
    }

    /**排序*/
    const onSortMenuClick = (e) => {
        if ("sort by name" == e.key || "sort by createDate" == e.key || "sort by updateDate" == e.key) {
            // updateSortOrderByMenu(e.key);
            setSortMenuOpen(true);
            localStorage.setItem(KEY_CANVAS_NOTE_SORT_TYPE,e.key);
            //默认选中Order by 的第一个.
            if("sort by name" == e.key){
                onSortMenuClick({key:'a-z'})
            }else{
                onSortMenuClick({key:'date desc'})
            }
        } else {
            setSortMenuOpen(false);
            localStorage.setItem(KEY_CANVAS_NOTE_ORDER_BY,e.key);
            //更新列表
            window.onUpdateNoteFilter();
        }
        updateSortStates();
    }

    /*排序菜单显示状态更改*/
    const handleSortOpenChange = (nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
            setSortMenuOpen(nextOpen);
        }
    }

    /**
     * 移除未使用的卡片--
     */
    const onRemoveUnusedCards = ()=>{
        const arrayMenuDatas = [...menuData];
        for (let i=arrayMenuDatas.length-1;i>=0;i--){
            const item = arrayMenuDatas[i];
            if (!item.hasRef){
                arrayMenuDatas.splice(i,1);
            }
        }
        setMenuData(arrayMenuDatas);
    }

    return(
        <>
            <Flex gap={"middle"} vertical style={{height:'100%',width:'100%',display:'none'}}>
                <Flex align="center" className="left-menu-title mt-6">
                    <span className='ml-4 font-family-medium font-size-12'>{props.title}</span>
                    <div style={{flexGrow: 1}}></div>
                    {/*<Button type="text" shape="circle" icon={<FolderOutlined rev={undefined}/>} onClick={onAddFolder}/>*/}
                    {/*<Button type="text" shape="circle" icon={<IconAddBlack/>} onClick={onAddItem}/>*/}
                    <Tooltip title={t("New card")} arrow={false}>
                        <img style={{marginRight: '10px'}}
                             className='img-mini-small-12 cursor-pointer' src={getImagePathWithTheme("add_black")}
                             onClick={onAddItem}/>
                    </Tooltip>


                    <ConfigProvider
                        theme={{
                            components: {
                                Dropdown: {
                                    colorBgElevated:'transparent',
                                    colorPrimaryBorder:'transparent',
                                    boxShadowSecondary:'transparent'
                                }
                            }
                        }}
                    >
                    <Dropdown overlayClassName='default-dropdown-style' placement={'bottomLeft'} overlayStyle={{minWidth: '232px'}}
                              menu={{items: sortMenu, onClick: onSortMenuClick}} trigger={['click']}
                              onOpenChange={handleSortOpenChange} open={sortMenuOpen} dropdownRender={(menu)=>{
                        return (
                            <div style={{background:'var(--dialog-background-color)',borderRadius:'8px',boxShadow:'var(--menu-box-shadow)'}}>
                                {React.cloneElement(
                                    menu as React.ReactElement<{
                                        style: React.CSSProperties;
                                    }>,
                                )}
                                <div className={'hovered-blue-no'} style={{color: '#E33E32',borderTop:'1px solid var(--line-color)',padding:'10px 22px',cursor:'pointer'}} onClick={()=>{
                                    setSortMenuOpen(false);
                                    window.showMessageBox(t("RemoveUnusedCards"),t("RemoveAllUnusedCardsTips"),t("Cancel"),t("Remove"),null,()=>{
                                        //移除未使用的card
                                        onRemoveUnusedCards();
                                    })
                                }}>
                                    <span>{t("RemoveUnusedCards")}</span>
                                </div>
                            </div>
                        )
                    }}>
                        <Tooltip title={t("Sort")} arrow={false}>
                        <Button type={"text"} className="small-button hovered" style={{marginLeft: '-2px'}}>
                            <img className="img-12" src={getImagePathWithTheme('left_card_sort')}/>
                        </Button>
                        </Tooltip>
                    </Dropdown>
                    </ConfigProvider>
                </Flex>

                <div id={'div-tree-note'} className='hovered-overflow-y-auto' style={{overflowX: "hidden", marginTop: '-10px'}}>
                    <ConfigProvider
                        theme={{
                            components: {
                                Tree:{
                                    colorPrimary:'var(--tree-item-select-color)'
                                }
                            }
                        }}
                    >
                        <DirectoryTree
                            className="tree-fuck-css-left-align"
                            switcherIcon={<CaretDownOutlined style={{color:'black',paddingTop:'6px'}} rev={undefined}/>}
                            expandedKeys={expandKeys}
                            onExpand={onExpand}
                            onSelect={onSelect}
                            treeData={arrayFilterMenuData/*太太太卡menuData.filter(p=>filterCurrentNotes(p))*/}
                            selectedKeys={treeSelectedKeys}
                            onRightClick={(info,node)=>{
                                setTreeSelectedKeys([info.node.key as string])
                            }}
                            showIcon={true}
                            blockNode={true}
                            draggable={treeDraggable}
                            onDragOver={onDragOver}
                            onDragStart={onDragStart}
                            onDragEnd={onDragEnd}
                            onDrop={onDrop}
                            // onMouseEnter={onTreeMouseEnter}
                            // onMouseLeave={onTreeMouseLeave}
                            titleRender={(nodeData:DataNode)=>{
                                if(nodeData.isEditable){
                                    return(
                                        <div style={{display:"flex",width:"196px",alignItems:"center"}}>
                                            <Input  className='default-font-size font-family-regular'
                                                    value={nodeData.editValue == t("Untitled")?'' : (nodeData.editValue || '')}
                                                   style={{color:nodeData.hasRef? "var(--text-color)":'var(--card-item-notin-project-color)',marginLeft:'0px',
                                                       paddingLeft:'0px',
                                                       flexGrow:1,
                                                       marginTop:'1px',
                                                       marginBottom:'0px'}}
                                                   variant={"borderless"}
                                                   autoFocus={true}
                                                   onKeyPress={(e)=>onCanvasKeyPress(e,nodeData.key)}
                                                   onChange={(e)=>onChange(e,nodeData.key)}
                                                   onBlur={(e)=>onBlur(e,nodeData.key)}
                                            />
                                            {/*<div style={{width:'16px',height:'16px',marginLeft:'16px'}}></div>*/}
                                        </div>
                                    )
                                }else{
                                    return(
                                        <Dropdown overlayClassName='default-dropdown-style' menu={{items}} trigger={['contextMenu']} overlayStyle={{width:'auto'}} onOpenChange={(open)=>{
                                            isMoreOpend = open;
                                        }}>
                                            <div className='custom-element' id={nodeData.key} style={{display:"flex",width:"196px",alignItems:"center"}}>
                                                <Input className='default-font-size font-family-regular'
                                                       readOnly={true} variant={"borderless"}
                                                       style={{color:nodeData.hasRef? "var(--text-color)":'var(--card-item-notin-project-color)',
                                                           marginLeft:'0px',paddingLeft:'0px',cursor:"pointer",
                                                           marginTop:'1px',
                                                           flexGrow:1,marginBottom:'0px'}}
                                                       value={(!nodeData.title || nodeData.title == t("Untitled"))?getNoteFirstHtmlForLeftCard(nodeData.noteDataDoc):nodeData.title}/>

                                                {/*<Dropdown menu={{items:items,onClick:onMoreClick}} trigger={['click']} onOpenChange={onMoreOpenChanged}>*/}
                                                {/*    <img className='img-mini-small-12 hovered' src={imgPathPerfix()+"vertical_more.png"}*/}
                                                {/*         style={{color:'#333333',visibility:nodeData.isHover?"visible":"hidden",*/}
                                                {/*             width:'18px',height:'18px',marginLeft:'12px',marginRight:'8px',padding:'4px'*/}
                                                {/*         }} />*/}
                                                {/*</Dropdown>*/}
                                            </div>
                                        </Dropdown>
                                    )
                                }
                            }}
                        />
                    </ConfigProvider>
                </div>
            </Flex>

            {/*<Modal title={t("Tips")} open={isMessageBoxShow} onOk={onMessageBoxOk} onCancel={()=>setIsMessageBoxShow(false)}>*/}
            {/*    <p>{t("Delete note not restore")}</p>*/}
            {/*</Modal>*/}

            <DialogMessageBox ref={dialogMessageBoxRef}/>

            {
                isShowNoteDialog && false &&
                <div className='alpha' onClick={()=>{
                    onDialogDismiss()
                }}>
                    <div onClick={(e)=>{
                        e.stopPropagation();
                    }}
                        style={{position:"fixed",height:isDialogFullScreen?"100%":dialogNoteEditSize.h,width:isDialogFullScreen?"100%":dialogNoteEditSize.h,
                        borderRadius:isDialogFullScreen?'0px':'10px',boxShadow:'0px 2px 6px 0px rgba(157,158,177,0.35)',
                        border:'1px solid #E6E3EE',
                        zIndex:'99',
                        overflow:'hidden',
                            backgroundColor:'white',
                        left:'50%',top:'50%',transform:'translate(-50%,-50%)'}}>
                        <DialogNote ref={dialogNoteRef} onCloseEvent={onCloseNoteEvent} onFullScreen={onFullScreen} element={mPendingElement} isReadonlyMode={isReadOnlyMode}/>
                    </div>
                </div>
            }


            {/*<Modal style={{position:isDialogFullScreen?"absolute":"relative",left:'-10px',*/}
            {/*    borderRadius:'0px',padding:'10px',overflowX:'hidden', overflowY:'hidden'}}*/}
            {/*       bodyStyle={{padding:'0px',margin:'-20px -24px',*/}
            {/*           height:dialogNoteEditSize.h,width:'calc(100% + 48px)',overflow:'hidden',left:'0px'}}*/}
            {/*       destroyOnClose={true} width={dialogNoteEditSize.w}*/}
            {/*       onCancel={onDialogDismiss}*/}
            {/*       centered={true}*/}
            {/*       title="" open={isShowNoteDialog}*/}
            {/*       closable={false} footer={''}*/}
            {/*       maskClosable={true}*/}
            {/*       afterOpenChange={(b)=>{*/}
            {/*           if(b && mPendingElement != undefined){*/}
            {/*               // dialogNoteRef.current.setNoteData(mPendingElement);*/}
            {/*               mPendingElement = null;*/}
            {/*           }*/}
            {/*       }}>*/}
            {/*        <div style={{margin:'0px',height:'100%',width:'100%'}}>*/}
            {/*            <DialogNote ref={dialogNoteRef} onCloseEvent={onCloseNoteEvent} onFullScreen={onFullScreen} element={mPendingElement} isReadonlyMode={isReadOnlyMode}/>*/}
            {/*        </div>*/}
            {/*    </Modal>*/}
        </>
    )
});

export default React.memo(TreeListNode);

function areEqual(prevProps: any, nextProps: any){
    // if (JSON.stringify(prevProps.element) == JSON.stringify(nextProps.element)){
    //     return true;
    // }
    return false
}